import { createContext } from 'react';

const trophysContext = createContext();

export default trophysContext;
